import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, IconButton, Link, Tooltip } from "@mui/material";
import theme from "Theme/AppTheme";
import { DRIVERS_HELP_CENTER_URL } from "components/UI/AcxEmptyStateIndicator/AcxEmptyState";
import type { AvailabilityInfoKind } from "./DataAvailability";

type Props = {
    kind: AvailabilityInfoKind;
    color?: string;
};

const helpCenterLink = (label: string) => (
    <Link
        href={DRIVERS_HELP_CENTER_URL}
        target="_blank"
        rel="noopener noreferrer"
        color="inherit"
        fontWeight={600}
    >
        {label}
    </Link>
);

const tooltipContent: Record<AvailabilityInfoKind, React.ReactNode> = {
    driversSpanning: (
        <>
            Displaying Drivers data only. Drivers replaced Topics on 7/1/26.
            Visit our {helpCenterLink("Help Center")} to learn how to view
            historical Topics data.
        </>
    ),
    topicsSpanning: (
        <>
            Displaying Topics data only. Drivers replaced Topics on 7/1/26.
            Visit our {helpCenterLink("Help Center")} to learn more.
        </>
    ),
    driversLateArrival: (
        <>
            Drivers replaced Topics on 7/1/26. This view is only showing data
            for interactions that arrived{"\u00a0"}after that date. Visit our{" "}
            {helpCenterLink("Help Center")} to learn how to view historical
            Topics data.
        </>
    ),
};

const DataAvailabilityInfo = ({ kind, color }: Props) => (
    <Tooltip
        arrow
        placement="top"
        title={
            <Box component="span" sx={{ fontSize: "13px", lineHeight: 1.5 }}>
                {tooltipContent[kind]}
            </Box>
        }
    >
        <IconButton
            size="small"
            aria-label="Data availability information"
            sx={{
                color: color ?? theme.palette.primary.main,
                padding: 0,
            }}
        >
            <InfoOutlinedIcon fontSize="small" />
        </IconButton>
    </Tooltip>
);

export default DataAvailabilityInfo;
